import initAxios from "./initAxios";

class CurrentUser {
  constructor(apiUrl) {
    this.axios = initAxios({ baseURL: apiUrl, withCredentials: true });
  }

  refreshBalance = () => this.axios.get("/v1/profile/balance/reload");

  refreshLicense = () => this.axios.get("/v1/profile/payedServices/reload");

  get = () => this.axios.get("/v1/profile");
}

export default CurrentUser;
